import qs from 'query-string';
import ClipboardJS from 'clipboard';
import Dialog, { ShareDialog } from 'share-dialog';

export function replaceQueryString(_: string, param: string, value: string) {
  const aa = qs.parse(location.search);
  aa[param] = value;

  return qs.stringify(aa);
}

export function isMobile(doc: HTMLElement) {
  return doc.scrollWidth < 768;
}

export function share(platform: 'facebook' | 'twitter' | 'linkedIn' | string) {
  const { href } = location;

  let dialog: ShareDialog;
  switch (platform) {
    case 'facebook': {
      const app_id = document
        .querySelector<HTMLMetaElement>('meta[property="fb:app_id"]')
        ?.getAttribute('content');

      dialog = Dialog.facebook().params({
        app_id,
        u: href,
      });
      break;
    }
    case 'twitter':
      dialog = Dialog.twitter(href, null, 'bonjoroapp');
      break;

    default:
      dialog = Dialog[platform](href);
  }

  dialog.open();
}

export function elById<E extends HTMLElement = HTMLElement>(
  id: string
): E | null {
  return document.getElementById(id) as E | null;
}

export function setupClipboard(
  el: ConstructorParameters<typeof ClipboardJS>[0],
  successMessage: string = 'Copied!',
  callback?: (event: ClipboardJS.Event) => void
) {
  const clipboard = new ClipboardJS(el);

  clipboard.on('success', (evt) => {
    evt.trigger.innerHTML = successMessage;
    evt.clearSelection();
    callback?.(evt);
  });
}

interface InternetExplorerRange {
  moveToElementText(el: HTMLElement): void;
  select(): void;
}

interface InternetExplorerDocument extends Document {
  selection: Selection | null;
  body: HTMLElement & {
    createTextRange(): InternetExplorerRange;
  };
}

function isIE(document: Document): document is InternetExplorerDocument {
  return document['selection'] != null;
}

export function selectText(containerId: string) {
  const container = elById(containerId);

  if (!container) {
    return;
  }

  if (isIE(document)) {
    // IE
    const range = document.body.createTextRange();
    range.moveToElementText(container);
    range.select();
  } else if (window.getSelection) {
    const range = document.createRange();
    range.selectNode(container);
    window.getSelection()?.removeAllRanges();
    window.getSelection()?.addRange(range);
  }
}

export function isValidUrl(value: string) {
  const re = new RegExp(
    '^(?:(?:(?:https?|ftp):)?\\/\\/)' + // protocol identifier (optional)
      '(?:\\S+(?::\\S*)?@)?' + // user:pass BasicAuth (optional)
      '(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})' + // IP address exclusion
      '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
      '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
      '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' + // IP address dotted notation octets
      '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
      '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
      '|' +
      '(?:(?:[a-z0-9\\u00a1-\\uffff][a-z0-9\\u00a1-\\uffff_-]{0,62})?[a-z0-9\\u00a1-\\uffff]\\.)+' + // host & domain names, may end with dot
      '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
      ')' +
      '(?::\\d{2,5})?' + // port number (optional)
      '(?:[/?#]\\S*)?' + // resource path (optional)
      '$',
    'i'
  );
  return re.test(value);
}
